export const removeHTMLFromString = (str) => str.replace(/<\/?[^>]+(>|$)/g, '');
